import React, { useEffect } from 'react'
import styles from "../myprofile/myprofile.module.css"
import ProfileMenu from '../../Components/profilemenu/ProfileMenu';
import AddNewUserComp from '../../Components/addNewUserComp/AddNewUserComp';
import Myprofile from '../myprofile/Myprofile';


const AddNewUser = () => {

   
    return (
        <>
            <Myprofile>

                <AddNewUserComp />
            </Myprofile>


        </>
    )
}

export default AddNewUser